import Select from "react-select";
import { Spinner } from "@fluentui/react";
import { FixedSizeList as List } from "react-window";

const CustomMenuList = ({ children }) => {
  const itemCount = Array.isArray(children) ? children.length : 0;
  const height = 35;
  const totalHeight = itemCount > 0 ? Math.min(300, itemCount * height) : height;

  if (itemCount === 0) {
    return null;
  }

  return (
    <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
      {({ index, style }) => (
        <div
          style={{
            ...style,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "0 8px",
            boxSizing: "border-box"
          }}
          title={children[index]?.props?.children}
        >
          {children[index]}
        </div>
      )}
    </List>
  );
};

const ContentApiSelector = ({ options, value, onChange, loading, disabled }) => (
  <div className="mb20">
    <label className="default-label">Select Cobrand</label>
    <Select
      isDisabled={disabled}
      isLoading={loading}
      options={options}
      value={value}
      onChange={onChange}
      placeholder="Select Cobrand"
      components={{ MenuList: CustomMenuList }}
      menuPortalTarget={document.body}
    />
    {loading && <Spinner label="Loading Content API settings..." />}
  </div>
);

export default ContentApiSelector;
